/*
  <H1 
    color={color} 
    size={size} 
    className={className}
  />
  - - - - - - - - - - - - -
  color -> white / black
  size -> xl / lg / md / sm / xs
  className -> css classes
  - - - - - - - - - - - - -
*/

export default function H1({
  color,
  className,
  desktopSize,
  mobileSize,
  children,
  ...props
}) {
  return (
    <h1
      className={`title tc-${color} title--${desktopSize}-d title--${mobileSize} ${className}`}
      {...props}
    >
      {children}
    </h1>
  );
}

H1.defaultProps = {
  color: "black",
  desktopSize: "xl",
  mobileSize: "md",
  className: "",
};
